// extracted by mini-css-extract-plugin
module.exports = {"box":"TerritoryCustomMap_box__1ElLm","boxBlack":"TerritoryCustomMap_boxBlack__31AC8"};